import * as React from 'react';
var headingLevelToTagMapper = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6',
};
var HeadingLevelContext = React.createContext({ topHeadingLevel: undefined });
export var useHeadingLevelContext = function (position) {
    var topHeadingLevel = React.useContext(HeadingLevelContext).topHeadingLevel;
    if (!topHeadingLevel) {
        return { headingLevel: undefined };
    }
    if (topHeadingLevel + (position - 1) > 6) {
        return { headingLevel: 'h6' };
    }
    return { headingLevel: headingLevelToTagMapper[topHeadingLevel + (position - 1)] };
};
export var HeadingLevelProvider = function (_a) {
    var children = _a.children, topHeadingLevel = _a.topHeadingLevel;
    return (React.createElement(HeadingLevelContext.Provider, { value: { topHeadingLevel: topHeadingLevel } }, children));
};
//# sourceMappingURL=heading-level-context.js.map